"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    'pixel2.wp.pl',
    'pixel.wp.pl',
];
